module.exports = __webpack_public_path__ + "static/media/avatar.cc93a967.jpg";